import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { Link } from "react-router-dom";
import { fetchAuthSession } from 'aws-amplify/auth';
import { Button, Breadcrumb, Modal, Table } from 'react-bootstrap';
import { useSnackbar } from 'notistack';
import { Helmet } from 'react-helmet-async';
import { ProductContext } from '../../../ProductProvider';
import InfoDeskForm from './InfoDeskForm';
import Preloader from '../../../components/Preloader/Preloader';

const config = require('../../../config.json');

export default function ActiveInfo() {
    const { validateLogin, loggedUser } = useContext(ProductContext);
    const { enqueueSnackbar } = useSnackbar();
    const [loaded, setLoaded] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [imageFile, setImageFile] = useState('');
    const [profileImage, setProfileImage] = useState('vjdepth-logo.png');
    const [infoDesk, setInfoDesk] = useState({ startDate: '', endDate: '', msgCategory: 'Flash News', msgStatus: 'Active' });
    const [flashNews, setFlashNews] = useState('');
    const [scrollMsg, setScrollMsg] = useState({ title: '', email: '', link: '', message: '', image: 'vjdepth-logo.png' });
    const [faithMsg, setFaithMsg] = useState({ title: '', head: '', message: '' });
    const [activePost, setActivePost] = useState([]);
    const [formType, setFormType] = useState("View");
    const [selectedItem, setSelectedItem] = useState('');

    useEffect(() => {
       if (loggedUser.isAuthenticated && loggedUser.profile === "Super Student") {
            fetchActiveInfo();
        } else {
            validateLogin();
        }       
    }, [loggedUser]);

    const toggleModal = () => {
        setModalOpen(!modalOpen);
    };

    const generateDate = async () => {
        const current_datetime = new Date();
        const date_year = (current_datetime.getFullYear()).toString();
        let date_month = (current_datetime.getMonth() + 1).toString();
        date_month = date_month.length === 1 ? '0' + date_month : date_month;
        let date_date = (current_datetime.getDate().toString());
        date_date = date_date.length === 1 ? '0' + date_date : date_date;
        return `${date_year}-${date_month}-${date_date}`;
    };

    const fetchActiveInfo = async () => {
        try {
            setLoaded(false);
            const { idToken } = (await fetchAuthSession()).tokens ?? {};
            const startDate = await generateDate();
            const clientID = "VJCollege";
            const searchOption = "All";
            await axios.get(`${config.api.invokeURL}/dashboard/infodesk?clientID=${clientID}&startDate=${startDate}&searchOption=${searchOption}`, {
                headers: {
                  Authorization: idToken,
                  'x-api-key': config.api.key
                }
            }).then((response) => {
                setActivePost(response.data || []);
                enqueueSnackbar(`${response.data.length} Active bulletin posts found`, { variant: 'success' }); 
                setLoaded(true);
            }).catch((error) => {
                enqueueSnackbar("Error: " + error.message, { variant: 'warning' }); 
                setLoaded(true);
            });
        } catch (error) {
            enqueueSnackbar("Error: " + error.message, { variant: 'warning' }); 
            setLoaded(true);
        }
    };

    const handleProjectView = (event, item) => {
        event.preventDefault();
        setInfoDesk({
            startDate: item.startDate,
            endDate: item.endDate,
            msgCategory: item.msgCategory || 'Flash News',
            msgStatus: item.msgStatus || 'Active'
        });
        setFlashNews(item.flashNews || '');
        setFaithMsg(item.faithMsg || { title: '', head: '', message: '' });
        setScrollMsg(item.scrollMsg || { title: '', email: '', link: '', message: '', image: 'vjdepth-logo.png' });
        const tImage = config.s3.scrollUrl + (item.scrollMsg?.image || 'vjdepth-logo.png');
        setProfileImage(tImage);
        setFormType("View");
        setModalOpen(true);
    };

    const handleProjectEdit = (event, item) => {
        event.preventDefault();
        setInfoDesk({
            startDate: item.startDate,
            endDate: item.endDate,
            msgCategory: item.msgCategory || 'Flash News',
            msgStatus: item.msgStatus || 'Active'
        });
        setFlashNews(item.flashNews || '');
        setFaithMsg(item.faithMsg || { title: '', head: '', message: '' });
        setScrollMsg(item.scrollMsg || { title: '', email: '', link: '', message: '', image: 'vjdepth-logo.png' });
        const tImage = config.s3.scrollUrl + (item.scrollMsg?.image || 'vjdepth-logo.png');
        setProfileImage(tImage);
        setFormType("Edit");
        setSelectedItem(item);
        setModalOpen(true);
    };

    const handleProjectDelete = async (event, item) => {
        event.preventDefault();
        try {
            const msgid = item.msgID;
            const { idToken } = (await fetchAuthSession()).tokens ?? {};  
            await axios.delete(`${config.api.invokeURL}/dashboard/infodesk/${msgid}`, {
                headers: {
                    Authorization: idToken,
                    'x-api-key': config.api.key
                }
            }).then(() => {
                enqueueSnackbar("Message successfully deleted", { variant: 'success' }); 
                fetchActiveInfo();
            }).catch((error) => {
                enqueueSnackbar("Error: " + error.message, { variant: 'warning' }); 
            });
        } catch (error) {
            enqueueSnackbar("Error: " + error.message, { variant: 'warning' }); 
        }
    };

    const postOnS3 = async (fileName) => {
        try {   
            const tnewFileName = fileName + ".jpeg";
            const keyName = 'images/infoDesk';
            const bucketName = config.s3.bucketName + keyName;
            const tfile = imageFile;
            const blob = tfile.slice(0, tfile.size, 'image/jpeg'); 
            const newFile = new File([blob], tnewFileName, { type: 'image/jpeg' });
            const { idToken } = (await fetchAuthSession()).tokens ?? {};
            
            await axios.get(`${config.api.invokeURL}/dashboard/images/presigned?fileName=${tnewFileName}&bucketName=${bucketName}`, {
                headers: {
                    Authorization: idToken,
                    'x-api-key': config.api.key
                }
            }).then(async (response) => {
                await fetch(response.data.uploadURL, {
                    method: 'PUT',
                    headers: { "Content-Type": "image/jpeg" },
                    body: newFile
                });
                setProfileImage(tnewFileName);
            }).catch((error) => {
                enqueueSnackbar("Error: " + error.message, { variant: 'warning' }); 
            });
        } catch (error) {
            enqueueSnackbar("Error: " + error.message, { variant: 'warning' }); 
        }
    };

    const handleProjectAdd = (event) => {
        event.preventDefault();
        setInfoDesk({ startDate: '', endDate: '', msgCategory: 'Flash News', msgStatus: 'Active' });
        setFlashNews('');
        setScrollMsg({ title: '', email: '', link: '', message: '', image: 'vjdepth-logo.png' });
        setFaithMsg({ title: '', head: '', message: '' });
        setFormType('Add');
        setModalOpen(true);
    };

    const EditMessage = async (event) => {
        event.preventDefault();
        try {
            if (!infoDesk.startDate || !infoDesk.endDate) {
                enqueueSnackbar("Start and End Date are required", { variant: 'info' }); 
                return;
            }
            if (infoDesk.startDate > infoDesk.endDate) {
                enqueueSnackbar("Start Date must be earlier than End Date", { variant: 'info' }); 
                return;
            }
            const msgid = selectedItem.msgID;
            let tscrollMsg = { ...scrollMsg };
            if (imageFile) {
                tscrollMsg.image = msgid + ".jpeg";
                await postOnS3(msgid);
            }

            const inputParams = {
                clientID: "VJCollege",
                msgID: msgid,
                startDate: infoDesk.startDate,
                endDate: infoDesk.endDate,
                msgCategory: infoDesk.msgCategory,
                msgStatus: infoDesk.msgStatus,
                flashNews: flashNews,
                scrollMsg: tscrollMsg,
                faithMsg: faithMsg
            };
            const { idToken } = (await fetchAuthSession()).tokens ?? {}; 
            await axios.patch(`${config.api.invokeURL}/dashboard/infodesk/${msgid}`, inputParams, {
                headers: {
                    Authorization: idToken,
                    'x-api-key': config.api.key
                }
            }).then(() => {
                enqueueSnackbar("Message successfully updated", { variant: 'success' }); 
                setModalOpen(false);
                fetchActiveInfo();
            }).catch((error) => {
                enqueueSnackbar("Error: " + error.message, { variant: 'warning' }); 
            });
        } catch (error) {
            enqueueSnackbar("Error: " + error.message, { variant: 'warning' }); 
        }
    };

    const AddNewMessage = async () => {
        try {
            if (!infoDesk.startDate || !infoDesk.endDate) {
                enqueueSnackbar("Start and End Date are required", { variant: 'info' }); 
                return;
            }
            if (infoDesk.startDate > infoDesk.endDate) {
                enqueueSnackbar("Start Date must be earlier than End Date", { variant: 'info' }); 
                return;
            }
            setLoaded(false);
            const msgid = new Date().getTime().toString();
            let tscrollMsg = { ...scrollMsg };
            if (imageFile) {
                tscrollMsg.image = msgid + ".jpeg";
                await postOnS3(msgid);
            } else {
                tscrollMsg.image = "vjdepth-logo.png";
            }
            const inputParams = {
                clientID: "VJCollege",
                msgID: msgid,
                startDate: infoDesk.startDate,
                endDate: infoDesk.endDate,
                msgCategory: infoDesk.msgCategory,
                msgStatus: infoDesk.msgStatus,
                flashNews: flashNews,
                scrollMsg: tscrollMsg,
                faithMsg: faithMsg
            };
            const { idToken } = (await fetchAuthSession()).tokens ?? {};
            await axios.post(`${config.api.invokeURL}/dashboard/infodesk/${msgid}`, inputParams, {
                headers: {
                    Authorization: idToken,
                    'x-api-key': config.api.key
                }
            }).then(() => {
                enqueueSnackbar("Bulletin post added successfully", { variant: 'success' }); 
                setModalOpen(false);
                fetchActiveInfo();
            }).catch((error) => {
                enqueueSnackbar("Error: " + error.message, { variant: 'warning' }); 
                setLoaded(true);
            });
        } catch (error) {
            enqueueSnackbar("Error: " + error.message, { variant: 'warning' }); 
            setLoaded(true);
        }
    };

    return (
        <div className="active-info-page animate-fade-in-up">
            <Helmet>
                <title>Campus Bulletins & InfoDesk - Vidyajyoti College</title>
                <meta name="description" content="Manage campus announcements and active news posts" />
                <link rel="canonical" href="/infodesk" />
            </Helmet>
           
            <Preloader show={!loaded} />

            {/* Breadcrumb */}
            <Breadcrumb>
                <Breadcrumb.Item>
                    <Link to="/">
                        <i className="fa fa-home" aria-hidden="true"></i> Dashboard
                    </Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item>Websites</Breadcrumb.Item>
                <Breadcrumb.Item active>InfoDesk</Breadcrumb.Item>
            </Breadcrumb>

            <div className="page-title-section">
                <div className="page-title-wrapper">
                    <h4>
                        <i className="fa fa-newspaper-o text-primary"></i> Campus Bulletins & InfoDesk
                    </h4>
                    <div className="page-subtitle">
                        Manage active notices, flash news, and college announcements
                    </div>
                </div>

                <Button 
                    variant="primary" 
                    size="sm"
                    onClick={handleProjectAdd}
                    className="d-inline-flex align-items-center gap-1"
                >
                    <i className="fa fa-plus"></i> New Announcement
                </Button>
            </div>

            {/* Modal */}
            <Modal onHide={toggleModal} show={modalOpen} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title className="fw-bold">
                        <i className="fa fa-bullhorn text-primary me-2"></i> Announcement - {formType}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4">
                    <InfoDeskForm 
                        infoDesk={infoDesk} 
                        setInfoDesk={setInfoDesk} 
                        flashNews={flashNews} 
                        setFlashNews={setFlashNews} 
                        scrollMsg={scrollMsg} 
                        setScrollMsg={setScrollMsg}
                        faithMsg={faithMsg} 
                        setFaithMsg={setFaithMsg} 
                        formType={formType} 
                        setImageFile={setImageFile} 
                        profileImage={profileImage} 
                        setProfileImage={setProfileImage} 
                    />
                </Modal.Body>
                <Modal.Footer className="d-flex justify-content-end gap-2"> 
                    <Button variant="light" onClick={toggleModal} style={{ borderRadius: '10px' }}>
                        Close
                    </Button>
                    {formType === "Add" && (
                        <Button variant="primary" onClick={AddNewMessage} style={{ borderRadius: '10px' }}>
                            <i className="fa fa-check me-1"></i> Post Announcement
                        </Button>
                    )}
                    {formType === "Edit" && (
                        <Button variant="primary" onClick={EditMessage} style={{ borderRadius: '10px' }}>
                            <i className="fa fa-refresh me-1"></i> Update Post
                        </Button>
                    )}
                </Modal.Footer>
            </Modal>    

            {/* Table of Active Bulletins */}
            <div className="table-wrapper">
                <Table hover responsive className="m-0">
                    <thead className="theadStyle">
                        <tr>
                            <th style={{ width: '60px' }}>#</th>
                            <th>Bulletin ID</th>
                            <th>Start Date</th>
                            <th>End Date</th>
                            <th>Category</th>
                            <th style={{ width: '140px' }} className="text-center">Actions</th>
                        </tr>
                    </thead>
                    <tbody className="tbodyStyle">
                        {activePost.length > 0 ? (
                            activePost.map((item, index) => (
                                <tr key={index} className="trStyle">
                                    <th scope="row" className="text-muted">{index + 1}</th>
                                    <td className="fw-semibold text-primary">{item.msgID}</td>
                                    <td>
                                        <span className="badge success">{item.startDate}</span>
                                    </td>
                                    <td>
                                        <span className="badge danger">{item.endDate}</span>
                                    </td>
                                    <td>
                                        <span className="badge gold">{item.msgCategory}</span>
                                    </td>
                                    <td className="text-center">
                                        <div className="d-flex align-items-center justify-content-center gap-2">
                                            <button 
                                                className="action-btn-circle" 
                                                onClick={e => handleProjectView(e, item)}
                                                title="View Announcement"
                                            >
                                                <i className="fa fa-eye"></i>
                                            </button>
                                            <button 
                                                className="action-btn-circle" 
                                                onClick={e => handleProjectEdit(e, item)}
                                                title="Edit Announcement"
                                            >
                                                <i className="fa fa-pencil"></i>
                                            </button>
                                            <button 
                                                className="action-btn-circle text-danger" 
                                                onClick={e => handleProjectDelete(e, item)}
                                                title="Delete Announcement"
                                            >
                                                <i className="fa fa-trash-o"></i>
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="6" className="text-center py-4 text-muted">
                                    No active announcements found. Click "New Announcement" to create one.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </div>
        </div>
    );
}
